export const reallocationsActions = {
  CLICK_REALLOCATION_CREATE: "CLICK_REALLOCATION_CREATE",
  CLICK_REALLOCATION_TRIGGER: "CLICK_REALLOCATION_TRIGGER",
  CLICK_REALLOCATION_UPDATE: "CLICK_REALLOCATION_UPDATE",
} as const;
